
import { Outlet } from "react-router";
import { SidebarProvider, useSidebar } from "../../contexts/sidebar-context";
import AppSidebar from "./app-sidebar";
import AppHeader from "./app-header";
import Backdrop from "./backdrop";

const LayoutContent: React.FC = () => {
  const { isExpanded, isHovered, isMobileOpen } = useSidebar();

  return (
    <>
      <div className="">
        <div className="z-5">
          <AppSidebar />
          <Backdrop/>
        </div>
        <div className="">
          <div
            className={` transition-all duration-300 overflow-hidden ease-in-out ${isExpanded || isHovered ? "lg:ml-[220px]" : "lg:ml-[70px]"
              } ${isMobileOpen ? "ml-0" : ""}`}
          >
            <AppHeader />
            <div id="main-section" className="p-2 container mt-[60px] mx-auto max-w-[98vw] overflow-auto md:p-3">
              <Outlet />
            </div>
            {/* <AppFooter /> */}
          </div>
        </div>
      </div>
    </>
  );
};

const AppLayout: React.FC = () => {
  return (
    <SidebarProvider>
      <LayoutContent />
    </SidebarProvider>
  );
};

export default AppLayout;
